import React from 'react';
import { Loader, Flex, Copy, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { RestrictionsList } from 'src/common/OrderRestrictions/RestrictionsList/RestrictionsList';
import { useMealCreditItemRestrictions } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ItemRestrictionsRule/hooks/useMealCreditItemRestrictions';

export function ItemRestrictionsRuleBody(): JSX.Element {
  const { isLoading, groupedItemRestrictions } =
    useMealCreditItemRestrictions();

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <Loader size="md" />
      </Flex>
    );
  }

  return (
    <>
      <Stack y="sm">
        <Copy variant="body">
          We recommend each company follow their internal ordering policies or
          guidelines to enforce these restrictions. The accuracy of our
          restricted item categories is not guaranteed.
        </Copy>
      </Stack>
      <RestrictionsList
        groupedRestrictions={groupedItemRestrictions}
        name="itemRestrictions"
      />
    </>
  );
}
